import { get, getOr, has, isEmpty, merge, omit, some } from 'lodash/fp'
import { createSelector } from 'reselect'

/**
 * @deprecated
 */
export const rootSelector = get('user')

/**
 * @deprecated
 */
export const accountSelector = createSelector(
  rootSelector,
  getOr({}, 'account'),
)

/**
 * @deprecated
 */
export const metaSelector = createSelector(
  rootSelector,
  omit(['data', 'account']),
)
/**
 * @deprecated
 */
export const fetchedSelector = createSelector(
  metaSelector,
  getOr(false, 'fetched'),
)

/**
 * @deprecated
 */
export const fetchingSelector = createSelector(
  metaSelector,
  getOr(false, 'fetching'),
)

/**
 * @deprecated
 */
export const loadingSelector = createSelector(
  metaSelector,
  ({ fetched, failed }) => !fetched && !failed,
)

/**
 * @deprecated
 */
export const userDataSelector = createSelector(rootSelector, get('data'))

/**
 * @deprecated use `usersQueries.usersCurrentDetails()` instead
 */
export const dataSelector = createSelector(
  userDataSelector,
  accountSelector,
  (data, account) => {
    const {
      given_name: first_name,
      family_name: last_name,
      phone,
      title,
      date_of_birth,
      job_title,
    } = account

    const email =
      has('identity.email', data) && isEmpty(data.identity.email)
        ? data.identity.email
        : account.email

    const userIdentity = merge(data?.identity, {
      date_of_birth,
      email,
      first_name,
      job_title,
      last_name,
      phone,
      title,
    })

    return omit('identity', { ...data, ...userIdentity })
  },
)

/**
 * @deprecated
 */
export const errorSelector = createSelector(metaSelector, get('error'))

/**
 * @deprecated
 */
export const requiresFetchSelector = createSelector(
  metaSelector,
  ({ fetching, fetched, failed, fresh }) =>
    // @ts-ignore Not sure if it works, while moving to TS leaving as is.
    !some(null, [fetching, fetched && fresh, failed && fresh]),
)

/**
 * @deprecated
 */
export const userLangSelector = createSelector(dataSelector, get('lang'))

/**
 * @deprecated
 */
export const idSelector = createSelector(dataSelector, get('id'))

/**
 * @deprecated
 */
export const hasCurrentSkillSelector = createSelector(
  dataSelector,
  getOr(false, 'current_skill_set'),
)
